/*
Akhila 11/19/2022 2700271704 Created new Component
akhila 11/21/2022 2700430604 removed another dialog box while search report and render search report in same component
akhila 11/21/2022 2700430604 imported Formula Rule search screen and added field in Add field Button
Sohel 11/21/2022 2700430604 Added validation
Prakash 11/22/2022 2700430604 Added conditional card spacing.
Sohel 11/22/2022 2700430604 fixed value disappearing issue
Guru Prasad 11/24/2022 2700430604 Fixed popup button alignments and added border.
Sohel 12/04/2022 2700271704 Account Update Group payload Changes
Dilip 12/05/2022  2700271704 Removed unnecessary console.log statements
Sohel 12/06/2022 2700271704 fixed data prepopulate issue
Prakash 12/06/2022 2700271704 Added useStates for conditional rendering popup width.
Sohel 12/07/2022 2700271704 fixed repository name prepopulate issue
Sohel 12/07/2022 2700271704 fixed reset button issue
kavyareddy 12/26/2022 2700271704 Renamed formulaCode to Data calaculation
sai krishna  1/2/2023 2700271704 add code and description
Akhila 01/27/2023 2700271704 bug fixed validation "Any of Value or Data calculation are required" issue
Raghu 02/23/2023 2700271704 fixed new Ui changes
Raghu 02/27/2023 2700271704 fixed new ui alignments
Raghu 02/28/2023 2700271704 fixed new ui alignments
Raghu 03/01/2023 2700271704 fixed new ui alignments
Prakash 13/04/2023 2700271704 remove margin
Akhila 05/31/2023 2700271704 unsaved changes bug fixed
Sohel 12/05/2023 2700271704 Repository Name and data calculation field removed grey color  
*/
import React, {useContext, useEffect, useState} from 'react';
import {Formik} from 'formik';
import {
  Button,
  FormHelperText,
  Grid,
  TextField,
  InputAdornment,
  Tooltip,
} from '@material-ui/core';
import ErrorBoundaryForComponents from '../../../../../util/ErrorBoundaryForComponents';
import * as Yup from 'yup';
import {ThemeContext} from '../../../../../themes/ThemeProvider';
import {Search, Clear, ArrowBack} from '@material-ui/icons';
import Globalfield from './../../../GlobalFields/DataRepositories/SearchDataRepositories/index';
import FormulaRuleGroup from './../../../BRE/FormulaRuleGroup/SearchRuleGroup/index';
import {Alert} from '@material-ui/lab';
import BreadCrums from '../../../../../util/BreadCrum';

const AddClientAccountForm = ({
  setClientFormData,
  clientFormData,
  setClientForm,
  clientRowData,
  setIsEdit,
  isEdit,
  searchEventTactics,
  setSearchEventTactics,
  openFormulaCode,
  setOpenFormulaCode,
  getValues,
  handleDirty,
}) => {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();

  // const [searchEventTactics, setSearchEventTactics] = useState(false);
  const [card, setCard] = useState(false);
  // const [openFormulaCode, setOpenFormulaCode] = useState(false);
  const [selectedGlobalField, setSelectedGlobalField] = useState({});
  const [selectedFormulaCode, setSelectedFormulaCode] = useState({});
  const [value, setValue] = useState('');
  const initialValues = {
    fieldCode: selectedGlobalField?.repositoryName ? selectedGlobalField?.repositoryName : '',
    description: selectedGlobalField?.fieldName ? selectedGlobalField?.fieldName : '',
    formulaCode: selectedFormulaCode?.code ? selectedFormulaCode?.code : '',
    formulaRuleGroupId:selectedFormulaCode?.groupId ? selectedFormulaCode?.groupId : "",
    fieldId:selectedGlobalField?.repositoryFieldId ? selectedGlobalField?.repositoryFieldId : "",
    dataRepositoryId:selectedGlobalField?.dataRepositoryId ? selectedGlobalField?.dataRepositoryId : "",
    value: value,
    fieldType: selectedGlobalField?.fieldType ? selectedGlobalField?.fieldType : '',
  };
  
  const handleEventTacticSearch = () => {
    setSearchEventTactics(false);
  };
  useEffect(() => {
    if (clientRowData) {
      const data = {
        repositoryName: clientRowData?.fieldCode,
        fieldName: clientRowData?.description,
        repositoryFieldId:clientRowData?.fieldId ? clientRowData?.fieldId : "",
        dataRepositoryId:clientRowData?.dataRepositoryId ? clientRowData?.dataRepositoryId : "",
      };
      setSelectedGlobalField(data);
      setSelectedFormulaCode({code: clientRowData?.formulaCode,groupId:clientRowData?.formulaRuleGroupId});
      setValue(clientRowData?.value);
    }
  }, [clientRowData, isEdit]);

  const schema = Yup.object().shape({
    fieldCode: Yup.string().required('Repository Name is required'),
    value: Yup.string().test(
      'value',
      'Any of Value or Data calculation are required',
      (val, formValues) => {
        const bothValPresent = [formValues?.parent?.value, formValues?.parent?.formulaCode].filter(
          Boolean,
        );
        const anyoneOneIsPresent = formValues?.parent?.value || formValues?.parent?.formulaCode;
        if (anyoneOneIsPresent && bothValPresent.length === 1) {
          return true;
        } else {
          return false;
        }
      },
    ),
  });

  const handleSubmit = (values) => {
    const data = {
      ...values,
    };
    const copyData = [...clientFormData];
    if (!isEdit) {
      copyData.push({...data});

      setClientFormData(copyData);
      setClientForm(false);
    } else {
      const updatedData = copyData.map((each, i) => {
        const {tableData} = clientRowData;
        if (each.tableData?.id === tableData?.id) {
          return {
            ...each,
            fieldCode: data?.fieldCode || '',
            formulaCode: data?.formulaCode,
            formulaRuleGroupId:data?.formulaRuleGroupId ? data?.formulaRuleGroupId : "",
            fieldId:data?.fieldId ? data?.fieldId : "",
            dataRepositoryId:data?.dataRepositoryId ? data?.dataRepositoryId : "",
            value: data?.value,
            description: data?.description,
            fieldType: data?.fieldType,
          };
        } else {
          return {
            ...each,
          };
        }
      });

      setClientFormData(updatedData);
      setIsEdit(false);
    }
    handleDirty(true);
  };
  return (
    <div>
      <div className={classes.dialoguecardStyles}>
        <Formik
          onSubmit={(values) => handleSubmit(values)}
          initialValues={initialValues}
          validationSchema={schema}
          enableReinitialize
          validateOnChange
        >
          {(props) => {
            const {
              values,

              handleSubmit,
              setFieldValue,
              handleReset,
              handleChange,
              touched,
              errors,
              resetForm,
              handleBlur,
            } = props;
            let currentErrMesg = '';
            let showValidations = null;
            if (errors?.value) {
              currentErrMesg = errors?.value;
              showValidations = touched.formulaCode;
            } else if (errors.formulaCode) {
              currentErrMesg = errors.formulaCode;
              showValidations = touched.value;
            }
            return (
              <>
                {searchEventTactics ? (
                  <>
                    <div className="new-standard-textfields">
                      <Button
                        variant="text"
                        className={`mb-3 search-btn`}
                        onClick={() => {
                          setSearchEventTactics(false);
                        }}
                      >
                        <ArrowBack className="mr-2" />
                        Go Back
                      </Button>
                    </div>
                    <Globalfield
                      handleEventTacticSearch={handleEventTacticSearch}
                      setSelectedGlobalField={setSelectedGlobalField}
                      addAccountUpdate={true}
                      isReports={true}
                      card={card}
                    />
                  </>
                ) : openFormulaCode ? (
                  <>
                    <div className="new-standard-textfields form-group">
                      <Button
                        variant="text"
                        className={`"mb-2" search-btn ${classes.buttonRoot}`}
                        onClick={() => {
                          setOpenFormulaCode(false);
                        }}
                      >
                        <ArrowBack className="mr-2" />
                        Go Back
                      </Button>
                    </div>
                    <FormulaRuleGroup
                      setOpenFormulaCode={setOpenFormulaCode}
                      addAccount={true}
                      setSelectedFormulaCode={setSelectedFormulaCode}
                      card={card}
                      selectedGlobalField={!isEdit ? selectedGlobalField : clientRowData}
                      addAccountUpdate={true}
                    />
                  </>
                ) : (
                  <div>
                    <BreadCrums
                      name={'Account Update Name'}
                      code={getValues()?.groupCode}
                      description={'Account Update Description'}
                      descriptionValue={getValues()?.description}
                    />
                    <form
                      autoComplete="off"
                      noValidate
                      onSubmit={handleSubmit}
                      onReset={handleReset}
                    >
                      <div className="global-field-textfields new-standard-textfields">
                        <ErrorBoundaryForComponents>
                          {values?.fieldCode && showValidations && currentErrMesg && (
                            <Alert className="mb-2" severity="error">
                              {currentErrMesg}
                            </Alert>
                          )}
                          <Grid container spacing={2}>
                            <Grid item xs={6} className="form-group wait-date-disable-field">
                              <TextField
                                margin="dense"
                                className={`${classes.labelName}`}
                                variant="outlined"
                                placeholder={`Enter Repository Name`}
                                label="Repository Name"
                                // InputLabelProps={{
                                //   shrink: true,
                                // }}
                                name="fieldCode"
                                value={values?.fieldCode}
                                onChange={(e) => {
                                  setFieldValue('fieldCode', e.target.value);
                                }}
                                fullWidth
                                handleBlur={handleBlur}
                                required
                                error={Boolean(errors?.fieldCode)}
                                disabled
                                InputProps={{
                                  endAdornment: (
                                    <InputAdornment position="end">
                                      <Tooltip title={'Search'}>
                                        <Search
                                          className={` ${classes.iconSearch}`}
                                          onClick={() => {
                                            setCard(true);
                                            setSearchEventTactics(true);
                                          }}
                                          size="sm"
                                        />
                                      </Tooltip>
                                      <Tooltip title={'Clear'}>
                                        <Clear
                                          className={` ${classes.iconSearch}`}
                                          onClick={() => setSelectedGlobalField({})}
                                        />
                                      </Tooltip>
                                    </InputAdornment>
                                  ),
                                }}
                              />
                              <FormHelperText style={{ color: 'red' }}>
                                {errors?.fieldCode && errors.fieldCode}
                              </FormHelperText>
                            </Grid>
                            {values?.fieldCode && (
                              <Grid item xs={6} className="form-group">
                                <TextField
                                  className={`${classes.labelName}`}
                                  margin="dense"
                                  variant="outlined"
                                  placeholder={`Enter Field Name`}
                                  label="Field Name"
                                  // InputLabelProps={{
                                  //   shrink: true,
                                  // }}
                                  name="description"
                                  value={values.description}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  disabled
                                  fullWidth
                                />
                              </Grid>
                            )}
                            {values?.fieldCode && (
                              <>
                                <Grid item xs={6} className="form-group">
                                  <TextField
                                    className={`${classes.labelName}`}
                                    margin="dense"
                                    variant="outlined"
                                    placeholder="Enter Value"
                                    label="Value"
                                    // InputLabelProps={{
                                    //   shrink: true,
                                    // }}
                                    name="value"
                                    value={values?.value}
                                    onChange={(e) => {
                                      setValue(e.target.value);
                                      setFieldValue('value', e.target.value);
                                    }}
                                    onBlur={handleBlur}
                                    fullWidth
                                  />
                                </Grid>
                                <Grid item xs={6} className="form-group wait-date-disable-field">
                                  <TextField
                                    margin="dense"
                                    className={`${classes.labelName}`}
                                    variant="outlined"
                                    placeholder={`Enter Data calculation `}
                                    label="Data calculation "
                                    // InputLabelProps={{
                                    //   shrink: true,
                                    // }}
                                    name="formulaCode"
                                    value={values?.formulaCode}
                                    onChange={(e) => {
                                      setFieldValue('formulaCode', e.target.value);
                                    }}
                                    fullWidth
                                    handleBlur={handleBlur}
                                    disabled
                                    InputProps={{
                                      endAdornment: (
                                        <InputAdornment position="end">
                                          <Tooltip title={'Search'}>
                                            <Search
                                              className={` ${classes.iconSearch}`}
                                              onClick={() => {
                                                setCard(true);
                                                setOpenFormulaCode(true);
                                              }}
                                              size="sm"
                                            />
                                          </Tooltip>
                                          <Tooltip title={'Clear'}>
                                            <Clear
                                              className={` ${classes.iconSearch}`}
                                              onClick={(e) => setSelectedFormulaCode({})}
                                            />
                                          </Tooltip>
                                        </InputAdornment>
                                      ),
                                    }}
                                  />
                                </Grid>
                              </>
                            )}
                          </Grid>
                        </ErrorBoundaryForComponents>
                      </div>
                      <div className="button-spacing-mb new-standard-textfields">
                        <Button
                          variant="outlined"
                          onClick={() => {
                            resetForm(initialValues);
                            if (clientRowData) {
                              const data = {
                                repositoryName: clientRowData?.fieldCode,
                                fieldName: clientRowData?.description,
                                repositoryFieldId:clientRowData?.fieldId ? clientRowData?.fieldId : "",
                                dataRepositoryId:clientRowData?.dataRepositoryId ? clientRowData?.dataRepositoryId : "",
                              };
                              setSelectedGlobalField(data);
                              setSelectedFormulaCode({code: clientRowData?.formulaCode,formulaRuleGroupId:clientRowData?.formulaRuleGroupId});
                              setValue(clientRowData?.value);
                            }
                          }}
                          className={`mx-1 reset-btn ${classes.buttonRoot}`}
                        >
                          Reset
                        </Button>
                        <Button
                          variant="outlined"
                          type="submit"
                          className={`search-btn mx-1 ${classes.buttonRoot}`}
                        >
                          Save
                        </Button>
                      </div>
                    </form>
                  </div>
                )}
              </>
            );
          }}
        </Formik>
      </div>
    </div>
  );
};

export default AddClientAccountForm;
